import React, { useState } from "react";
import {
    FaWhatsapp,
    FaFacebook,
    FaInstagram,
    FaRegClipboard,
    FaClipboardCheck
} from "react-icons/fa";
import toast from 'react-hot-toast';

import './index.scss'

const ShareButton = ({ text, url, setShowButtons }) => {
    const message = encodeURIComponent(`${text} ${url}`);

    // Social media share handlers
    const handleInstagramShare = () => {
        window.open(`https://www.instagram.com`,"_blank");
    };

    const handleFacebookShare = () => {
        window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
            "_blank"
        );
    };

    const handleWhatsAppShare = () => {
        window.open(`https://api.whatsapp.com/send?text=${message}`, "_blank");
    };

    // Clipboard functionality
    const [copied, setCopied] = useState(false);
    const handleCopy = () => {
        navigator.clipboard.writeText(url).then(() => {
            setCopied(true);
            toast.success('Link copiado com sucesso!');
            setTimeout(() => setCopied(false), 1500);
        });
    };

    setTimeout(() => setShowButtons(true), 60000);

    return (
        <div className="custom-share">
            <span onClick={() => setShowButtons(true)} className="custom-share-close">&times;</span>
            <section className="my-2 flex-center flex-col">
                <div className=" items-center justify-center bg-gray-100 py-2 ">
                    <p className="text-start roboto-medium">Compartilhar na Redes Sociais</p>
                    <div className="flex space-x-4 py-3 share-btn-group">
                        <button
                            onClick={handleFacebookShare}
                            className="flex items-center justify-center p-2 bg-blue-500 text-white rounded-full hover:bg-blue-600"
                        >
                            <FaFacebook size={24} />
                        </button>
                        <button
                            onClick={handleInstagramShare}
                            className="flex items-center justify-center p-2 bg-blue-500 text-white rounded-full hover:bg-blue-600"
                        >
                            <FaInstagram size={24} />
                        </button>   
                        <button
                            onClick={handleWhatsAppShare}
                            className="flex items-center justify-center p-2 bg-green-500 text-white rounded-full hover:bg-green-600"
                        >
                            <FaWhatsapp size={24} />
                        </button>
                    </div>
                </div>

                {/* Copy URL Section */}
                <div className="flex flex-col items-center justify-center bg-gray-100 mb-2 py-2">
                    <p className="text-start roboto-medium mb-4">Copiar URL de Link</p>
                    <div className="flex items-center justify-center">
                        <button
                            onClick={handleCopy}
                            className={`flex items-center justify-center p-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition duration-200 ${copied ? "bg-green-600 hover:bg-green-700" : ""
                                }`}
                        >
                            {copied ? (
                                <FaClipboardCheck size={24} />
                            ) : (
                                <FaRegClipboard size={16} />
                            )}
                            &nbsp; <span className="ml-2">{copied ? "Copiado!" : "Copiar URL"}</span>
                        </button>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ShareButton;